import { render, staticRenderFns } from "./GlobalHeaderBar.vue?vue&type=template&id=44979c9d&scoped=true&"
import script from "./GlobalHeaderBar.vue?vue&type=script&lang=js&"
export * from "./GlobalHeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalHeaderBar.vue?vue&type=style&index=0&id=44979c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44979c9d",
  null
  
)

export default component.exports